import { render, staticRenderFns } from "./Son.vue?vue&type=template&id=e4e0080a&scoped=true"
import script from "./Son.vue?vue&type=script&lang=js"
export * from "./Son.vue?vue&type=script&lang=js"
import style0 from "./Son.vue?vue&type=style&index=0&id=e4e0080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e0080a",
  null
  
)

export default component.exports